import React from 'react';
import './AnswerCapsule.css';

/**
 * AnswerCapsule — 2-3 sentence direct answer at top of informational pages.
 * Feeds Google's AI Overview (AIO) with a structured, crawlable answer.
 *
 * @param {string} question   - The user's implicit search query (shown as aria-label)
 * @param {string} answer     - The 2-3 sentence direct answer
 * @param {string} [badge]    - Optional short label, e.g. "Quick Answer"
 */
const AnswerCapsule = ({ question, answer, badge = 'Quick Answer' }) => {
  if (!answer) return null;
  return (
    <div className="answer-capsule" aria-label={question} itemScope itemType="https://schema.org/Answer">
      <span className="answer-capsule-badge">{badge}</span>
      <p className="answer-capsule-text" itemProp="text">{answer}</p>
    </div>
  );
};

export default AnswerCapsule;
